$(document).ready(function() {
	if(!document.querySelector('.GPC0064')) return false;

	var socialComponent = function(){
		var slideContainer = $('.GPC0064');
		var slideTarget = slideContainer.find('.block-wrap');
		slideTarget.slick({
			infinite: false, // WA-GPC0064-02
			listStyle: true, // WA-GPC0064-02
			slidesToShow: 4,
			slidesToScroll: 1,
			nextArrow:slideContainer.find('.social-next'),
			prevArrow:slideContainer.find('.social-prev'),
			dots:true,
			appendDots:slideContainer.find('.slick-dot-wrap'),
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						autoplay: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false
					}
				}
			]
		});
	};

	function makeHTML(social, url, text, image, isVideo) {
		//console.log(social);
		var articleType;
		if(isVideo) articleType = "video-text-type";
		else if(image && text) articleType = "image-text-type";
		else if(image && !text) articleType = "image-type";
		else articleType = "text-type";

		var tempType;
		var $obj;
		if(articleType=="video-text-type") $obj = $('.GPC0064 #socialTemplateVideo');
		else if(articleType=="image-text-type") $obj = $('.GPC0064 #socialTemplateImageTxt');
		else if(articleType=="image-type") $obj = $('.GPC0064 #socialTemplateImage');
		else if(articleType=="text-type") $obj = $('.GPC0064 #socialTemplateText');

		articleType = '.'+articleType;

		var obj = $obj.clone().html();
		var html = obj.replace(/\*url\*/g, url)
					.replace(/\*text\*/g, text)
					.replace(/\*alt\*/g, '')
					.replace(/\*image\*/g, image)
					.replace(/\*social\*/g, social);

		//console.log(html);
		return html;
	}
	var getSocialPosts = {
		comp: $('.GPC0064'),
		el: $('.GPC0064 .block-wrap'),
		info: {
			facebook : {
				url : null
			},
			twitter : {
				url : null
			},
			instagram : {
				url : null
			},
			youtube : {
				url : null
			},
			eachCount: 0,
			snsCount: 0
		},
		init: function() {
			var snsList = [];
			$(getSocialPosts.el).find('>div').each(function(idx) {
				if($(this).hasClass('facebook-info')) {
					snsList[idx] = 'facebook';
					getSocialPosts.info.facebook.url = $(this).data('url');
				} else if($(this).hasClass('twitter-info')) {
					snsList[idx] = 'twitter';
					getSocialPosts.info.twitter.url = $(this).data('url');
				} else if($(this).hasClass('instagram-info')) {
					snsList[idx] = 'instagram';
					getSocialPosts.info.instagram.url = $(this).data('url');
				} else if($(this).hasClass('youtube-info')) {
					snsList[idx] = 'youtube';
					getSocialPosts.info.youtube.url = $(this).data('url');
				}
			});
			socialComponent();
			getSocialPosts.info.snsCount = snsList.length;
			if(getSocialPosts.info.snsCount == 1) {
				getSocialPosts.info.eachCount = 4;
			} else {
				getSocialPosts.info.eachCount = 2;
			}
			if(getSocialPosts.info.snsCount>0) {
				for(var i=0;i<getSocialPosts.info.snsCount;i++) {
					if(snsList[i]=='facebook') {
						$(getSocialPosts.el).find('.facebook-info').remove();
						getSocialPosts.facebook(i);
					} else if(snsList[i]=='twitter') {
						$(getSocialPosts.el).find('.twitter-info').remove();
						getSocialPosts.twitter(i);
					} else if(snsList[i]=='instagram') {
						$(getSocialPosts.el).find('.instagram-info').remove();
						getSocialPosts.instagram(i);
					} else if(snsList[i]=='youtube') {
						$(getSocialPosts.el).find('.youtube-info').remove();
						getSocialPosts.youtube(i);
					}
				}
			} else {
				// no social media, remove GPC0064 (except admin)
				if(!$('body').hasClass('iw-fullscreen-edit') && !$('.GPC0064').has('.iframe-container')) {
					$('.GPC0064').remove();
				}
			}
		},
		facebook: function(num) {
			ajax.call(getSocialPosts.info.facebook.url, {}, 'json', function(d){
				if(d && d.data) {
					var data = d.data[0].feeds;
					if(data != null) {
						for(var i=0;i<data.length;i++){
							if(i>=getSocialPosts.info.eachCount) return;
							var linkUrl = 'https://www.facebook.com/'+data[i].id.split('_')[0]+'/posts/'+data[i].id.split('_')[1];
							var isVideo = (data[i].type=='video_autoplay') ? true:false;
							var mediaURL = '';
							if(data[i].media) {
								mediaURL = data[i].media.image.src;
							}
							var text = xssfilter(data[i].message);
							var html = makeHTML('facebook', linkUrl, text, mediaURL, isVideo);
							getSocialPosts.appendHTML('facebook', html, num, i);
						}
					}
				}
			}, 'get', '.GPC0064');
		},
		twitter: function(num) {
			ajax.call(getSocialPosts.info.twitter.url, {}, 'json', function(d){
				if(d && d.data) {
					var data = d.data[0].userTimeline;
					var userName = d.data[0].userName;
					if(data != null) {
						for(var i=0;i<data.length;i++){
							if(i>=getSocialPosts.info.eachCount) return;
							var linkUrl = 'https://twitter.com/'+userName+'/status/'+data[i].id;
							var mediaURL= '';
							var isVideo = false;
							if(data[i].mediaEntity.length>0) {
								var mtype = data[i].mediaEntity[0].type;
								if(mtype=='animated_gif' || mtype=='photo') {
									mediaURL = (location.protocol=='http:') ? data[i].mediaEntity[0].mediaURL : data[i].mediaEntity[0].mediaURLHttps;
									isVideo = false;
								} else if(mtype=='video') {
									mediaURL = (location.protocol=='http:') ? data[i].mediaEntity[0].mediaURL : data[i].mediaEntity[0].mediaURLHttps;
									isVideo = true;
								}
							}
							var text = xssfilter(data[i].text);
							var html = makeHTML('twitter', linkUrl, text, mediaURL, isVideo);
							getSocialPosts.appendHTML('twitter', html, num, i);
						}
					}
				}
			}, 'get', '.GPC0064');
		},
		instagram: function(num) {
			ajax.call(getSocialPosts.info.instagram.url, {}, 'json', function(d){
				if(d && d.data) {
					var data = d.data[0].feeds;
					if(data != null) {
						for(var i=0;i<data.length;i++){
							if(i>=getSocialPosts.info.eachCount) return;
							// 20200325 START 박지영 : instagram 업데이트
							var linkUrl = data[i].permalink;
							var isVideo = (data[i].media_type=='VIDEO') ? true:false;
							var mediaURL = '';
							if(data[i].media_type=='VIDEO') {
								mediaURL = data[i].thumbnail_url;
							// 20200326 START 박지영 : media type 추가
							} else if(data[i].media_type=='IMAGE') {
								mediaURL = data[i].media_url;
							// 20200326 END
							} else if(data[i].media_type=='CAROUSEL_ALBUM') {
								mediaURL = data[i].media_url;
							}
							var text = xssfilter(data[i].caption);
							// 20200325 END
							var html = makeHTML('instagram', linkUrl, text, mediaURL, isVideo);
							getSocialPosts.appendHTML('instagram', html, num, i);
						}
					}
				}
			}, 'get', '.GPC0064');
		},
		youtube: function(num) {
			ajax.call(getSocialPosts.info.youtube.url, {}, 'json', function(d){
				if(d && d.data) {
					var data = d.data[0].feeds;
					if(data != null) {
						for(var i=0;i<data.length;i++){
							if(i>=getSocialPosts.info.eachCount) return;
							var linkUrl = 'https://www.youtube.com/watch?v='+data[i].id.videoId;
							var mediaURL= (data[i].snippet.thumbnails.high) ? data[i].snippet.thumbnails.high.url : data[i].snippet.thumbnails.medium.url;
							var isVideo = true;
							var text = xssfilter(data[i].snippet.title); // data[i].snippet.description
							var html = makeHTML('youtube', linkUrl, text, mediaURL, isVideo);
							getSocialPosts.appendHTML('youtube', html, num, i);
						}
					}
				}
			}, 'get', '.GPC0064');
		},
		appendHTML : function(sns, html, num, i) {
			console.log(sns, num, i);
			setTimeout(function() {
				if(num==0) $(getSocialPosts.el).slick('slickAdd',html);
				else if(num>0 && i==0) $(getSocialPosts.el).slick('slickAdd',html, (num-1));
				else $(getSocialPosts.el).slick('slickAdd',html);
			}, (num*100));
		}
	}
	getSocialPosts.init();
});